import React, { FC } from 'react';
import PaginationContextProvider from './PaginationContext';

const ContextProvider: FC = ({ children }) => {
  return <PaginationContextProvider>{children}</PaginationContextProvider>;
};

export default ContextProvider;
